import React from "react";
import "./Footer.css";
import { FaLinkedin, FaEnvelope } from "react-icons/fa";
import logoImg from "../../assets/logo.png";
import { useLanguage } from "../../context/LanguageContext"; // Import

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-content">
          {/* Logo / Brand */}
          <div className="footer-brand">
            <a href="#hero">
              <img src={logoImg} alt="OneTicket Logo" className="logo-img" />
            </a>
            <p>{t.footer.slogan}</p>
          </div>

          {/* Liens Rapides */}
          <div className="footer-links">
            <h4>{t.footer.navTitle}</h4>
            <ul>
              <li>
                <a href="#hero">{t.header.home}</a>
              </li>
              <li>
                <a href="#concept">{t.header.concept}</a>
              </li>
              <li>
                <a href="#services">{t.header.services}</a>
              </li>
              <li>
                <a href="#faq">FAQ</a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-contact">
            <h4>{t.footer.contactTitle}</h4>
            <p>
              <a href="mailto:hello@acefund.io">
                <FaEnvelope /> hello@acefund.io
              </a>
            </p>
            <div className="social-icons">
              <a href="https://www.linkedin.com/showcase/oneticketbyacegood/?viewAsMember=true">
                <FaLinkedin />
              </a>
            </div>
            <a href="mailto:hello@one-ticket.be" className="btn-contact-footer">
              {t.footer.btnContact}
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; {new Date().getFullYear()} OneTicket. {t.footer.copyright}
          </p>
          <div className="legal-links">{/* Liens légaux à venir */}</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
